module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.editingState.id !== 0) ? _c('div', {
    staticClass: "editing-box",
    style: (_vm.getStyle),
    attrs: {
      "draggable": "true"
    },
    on: {
      "dragstart": _vm.dragstartHandler,
      "dragend": _vm.dragendHandler
    }
  }, [_c('div', [_vm._v("\n    " + _vm._s(_vm.$store.state.editingState.start) + " ~\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.$store.state.editingState.end) + "\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.getStudent()) + " 様\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    " + _vm._s(_vm.getTeacher()) + " 先生\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888888"
    }
  }, [_vm._v("\n    ドラッグで移動\n  ")])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d5deb2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d5deb2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/EditingBox.vue
// module id = 724
// module chunks = 0